const DividerComponent = ({ data }) => {
  return <hr className={`${data?.class || ""}`} />;
};

export default DividerComponent;
